import { button } from '@sparta.global.helpers/button-helper/dist/es5.js';
var CLOSING_MARKUP = '</div></div>';

/**
 * Creates the base markup for the MLO information.
 * @param {Object} mloInformation The MLO information
 * @param {Object} form JCR Form section
 * @returns {String} Generated HTML
 */
function createBaseMarkup(mloInformation, form) {
  var photoURL = mloInformation.photoURL,
    firstName = mloInformation.firstName,
    lastName = mloInformation.lastName,
    nmlsid = mloInformation.nmlsid;
  var nmlsID = form.nmlsID;
  var mloPhotoUrl = photoURL ? "<img onerror=\"this.parentNode.removeChild(this)\" src=\"".concat(photoURL, "\"/>") : '&nbsp';
  var baseDetails = "<div class=\"dme-box-container mlo-main-content\">\n      <div class=\"inner-container\">\n        <div class=\"img-picture-container\">\n          <div class=\"img-column\">".concat(mloPhotoUrl, "</div>\n          <div class=\"name-column\">\n            <h3 class=\"name-container headline-small cnx-light\">").concat(firstName, " ").concat(lastName, "</h3>\n            <span class=\"nmls-container body-small dme-gray-text\">").concat(nmlsID, ": ").concat(nmlsid, "</span>\n          </div>\n        </div>");
  return baseDetails;
}

/**
 * Formats MLO phone numbers by segments split by periods.
 * @param {String} phoneNumber Unformatted phone number
 * @returns {String} Formatted phone number
 */
function formatMloPhoneNumber(phoneNumber) {
  return "".concat(phoneNumber.slice(0, 3), ".").concat(phoneNumber.slice(3, 6), ".").concat(phoneNumber.slice(6));
}

/**
 * Generates phone number information HTML
 * @param {Object} mloInformation MLO Information
 * @param {Object} form JCR Form section
 * @returns {String} Generated HTML
 */
function generatePhoneNumberMarkup(mloInformation, form) {
  var phoneNumber = mloInformation.phoneNumber,
    phoneExt = mloInformation.phoneExt;
  var formattedMLOPhone = formatMloPhoneNumber(phoneNumber);
  var callNow = form.callNow;
  var mloPhoneExt = phoneExt ? " x.".concat(phoneExt) : '';
  return "<hr>\n    <div class=\"line-item\">\n      <p>\n        <a href=\"tel:".concat(phoneNumber, "\">").concat(callNow, "</a><br />\n        <span class=\"body-small dme-gray-text\">").concat(formattedMLOPhone).concat(mloPhoneExt, "</span>\n      </p>\n    </div>");
}

/**
 * Generates email information HTML
 * @param {Object} mloInformation MLO Information to generate from.
 * @param {Object} form JCR Form section
 * @param {Boolean} isHelpIcon Whether or not this is from the header help tooltip
 * @returns {String} Generated html
 */
function generateEmailMarkup(mloInformation, form, isHelpIcon) {
  var email = mloInformation.email;
  var copiedEmail = form.copiedEmail;
  var emailText = form.email;
  var helpIconClassModifier = isHelpIcon ? '-help-icon' : '';
  return "<hr>\n    <div class=\"line-item mlo-email-body-container".concat(helpIconClassModifier, "\">\n      <p>\n        <a class=\"mlo-email-body-header").concat(helpIconClassModifier, " mlo-email-info\" href=\"mailto:").concat(email, "\">\n          ").concat(emailText, "<br />\n        </a>\n        <span class=\"mlo-email-body mlo-email-info body-small dme-gray-text\">").concat(email, "</span>\n        <span class=\"mlo-copied-body hide\">").concat(copiedEmail, "</span>\n      </p>\n    </div>");
}

/**
 * Generates a callback line
 * @param {Object} form The Form Links section of JCR
 * @returns {String} Wrapped html
 */
function generateGetACallBack(form) {
  var _form$callMeBackLink = form.callMeBackLink,
    ID = _form$callMeBackLink.ID,
    CLASS = _form$callMeBackLink.CLASS,
    content = _form$callMeBackLink.content;
  var config = {
    attributes: {
      id: ID
    },
    classes: CLASS,
    modifiers: 'link',
    content: content
  };
  return "<hr><div class=\"line-item\">".concat(button(config), "</div>");
}

/**
 * Copies the MLO email into the customer's clipboard.
 * @returns {void}
 */
function copyEmail() {}

/**
 * Initializes the MLO information and returns it in a HTML string.
 * @param {Object} dataReceived Backend received data
 * @param {Object} dataSource Copy / JCR
 * @param {Boolean} isHelpIcon Whether or not this is from the header help tooltip
 * @returns {String} Generated HTML
 */
function initMlo(dataReceived, dataSource) {
  var isHelpIcon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mloInformation = dataReceived.mloInformation,
    primaryApplicantPhone = dataReceived.primaryApplicantPhone;
  var phoneNumber = mloInformation.phoneNumber,
    email = mloInformation.email,
    isGetACallBackEnabled = mloInformation.isGetACallBackEnabled;
  var form = dataSource.form,
    LINKS = dataSource.LINKS;
  var baseMarkup = createBaseMarkup(mloInformation, form);
  var phoneNumberMarkup = phoneNumber ? generatePhoneNumberMarkup(mloInformation, form) : '';
  var emailMarkup = email ? generateEmailMarkup(mloInformation, form, isHelpIcon) : '';
  var getACallBackMarkup = isGetACallBackEnabled && primaryApplicantPhone ? generateGetACallBack(LINKS) : '';
  return "".concat(baseMarkup).concat(phoneNumberMarkup).concat(emailMarkup).concat(getACallBackMarkup).concat(CLOSING_MARKUP);
}
var index = {
  initMlo: initMlo,
  copyEmail: copyEmail
};
export { index as default };